import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "/",
      name: 'root',
      redirect: () => process.env.VUE_APP_ROLE === 'client' ? '/client/orders' : '/vehicles',
      component: () => import("@/view/layout/Layout"),
      children: [
        {
          path: "/vehicles",
          name: "vehicles",
          component: () => import("@/view/pages/Vehicles.vue")
        },
        {
          path: "/orders",
          name: "orders",
          component: () => import("@/view/pages/Orders.vue")
        },
        {
          path: "/active-orders",
          name: "active-orders",
          component: () => import("@/view/pages/ActiveOrders.vue")
        },
        {
          path: "/messages",
          name: "messages",
          component: () => import("@/view/pages/Messages.vue")
        },
        {
          path: "/profile",
          name: "profile",
          component: () => import("@/view/pages/Profile.vue")
        }
      ]
    },
    {
      path: "/",
      name: 'client',
      component: () => import("@/view/layout/Layout"),
      children: [
        {
          path: "client/orders",
          name: "client_orders",
          component: () => import("@/view/pages/client/Orders.vue")
        }
      ]
    },
    {
      path: "/",
      name: 'client',
      component: () => import("@/view/layout/LayoutMap"),
      children: [
        {
          path: "client/map",
          name: "client_map",
          component: () => import("@/view/pages/client/Map.vue")
        }
      ]
    },
    {
      path: "/",
      component: () => import("@/view/pages/auth/Auth"),
      children: [
        {
          name: "login",
          path: "/login",
          component: () => import("@/view/pages/auth/Login")
        },
        {
          name: "register",
          path: "/register",
          component: () => import("@/view/pages/auth/Register")
        },
        {
          name: "confirm",
          path: "/confirm",
          component: () => import("@/view/pages/auth/Confirm")
        },
        {
          name: "restore",
          path: "/restore",
          component: () => import("@/view/pages/auth/Restore")
        },
        {
          name: "logout",
          path: "/logout",
          component: () => import("@/view/pages/auth/Logout")
        }
      ]
    },
    {
      path: "*",
      redirect: "/404"
    },
    {
      // the 404 route, when none of the above matches
      path: "/404",
      name: "404",
      component: () => import("@/view/pages/error/Error-1.vue")
    }
  ]
});
